import { css } from 'styled-components';
import { colours } from './colours';

export const focusOutline = css`
  box-shadow: 0 0 0 5px ${colours.WHITE};
  outline: ${colours.OUTLINE_BORDER} solid 3px;
  outline-offset: 2px;
`;
